import type { PropsWithChildren } from 'react';
import clsx from 'clsx';
import React from 'react';

import type { TWMaxHeightProp } from '../../types/tailwind';

export type ResponsiveOffsetProps<HeightProp> = {
  verticalOffset: TWMaxHeightProp<HeightProp> | (string & NonNullable<unknown>);
  shouldCenter: boolean;
};

export const ResponsiveOffset = <HeightProp,>({
  verticalOffset,
  children,
  shouldCenter,
}: PropsWithChildren<ResponsiveOffsetProps<HeightProp>>) => (
  <div className="flex flex-col h-full w-full">
    <div className={clsx('h-full w-full', verticalOffset)} />
    <div>{children}</div>
    {shouldCenter && <div className={clsx('h-full w-full', verticalOffset)} />}
  </div>
);
